import { cn } from '~/lib/cn';

export interface CellProps {
  children?: React.ReactNode;
  className?: string;
}

const TableTh = (props: CellProps): JSX.Element => {
  return (
    <th
      className={cn(
        'px-sm py-xs text-left text-body-sm font-semibold text-subtle',
        props.className,
      )}
    >
      {props.children}
    </th>
  );
};

TableTh.displayName = 'TableTh';

const TableTd = (props: CellProps): JSX.Element => {
  return (
    <td className={cn('px-sm py-xs text-body-sm', props.className)}>
      {props.children}
    </td>
  );
};

TableTd.displayName = 'TableTd';

export { TableTd, TableTh };
